
// Types = Width x Height
// 1 = 1x2
// 2 = 2x1
// 3 = 2x2
// 4 = 3x1
// 5 = 2x2 Diagonal Up
// 6 = 1x1 
// 7 = 2x1 Diagonal Down

// Levels = Available Types
// 1 = 1, 2, 3, 6
// 2 = 1, 2, 4, 5
// 3 = 1, 4, 5, 6
// 4 = 3, 5, 6, 7

// Positioning
// Types expand to the right 
// A 1x1 block placed on lane 1 will block lane 1
// A 2x1 block placed on lane 1 will block lane 1 and 2
// A 3x1 block placed on lane 1 will block lane 1, 2 and 3
// A 2x1 block can only be placed on lane 1 or 2 not on 3 as it would overshoot
// A 2x1 block can be placed on lane 3 if it's flipped making it block line 3 and 2 
// Keep authored positions outside track transition areas.

// Current Traansition Regions
// 1 = 560 - 650
// 2 = 1370 - 1480
// 3 = 2770 - 2850

export type PathObstaclePlacement = {
    position: number
    track: number
    type: number
    flip: 0 | 1
}

export const obstaclePositions: PathObstaclePlacement[] = [
    // Level 1 Tutorial
    { position: 50, track: 2, type: 1, flip: 1 },
    { position: 50, track: 1, type: 1, flip: 1 },

    { position: 80, track: 3, type: 1, flip: 1 },

    { position: 110, track: 1, type: 1, flip: 1 },
    { position: 110, track: 2, type: 6, flip: 1 },
    { position: 110, track: 3, type: 1, flip: 1 },

    // Level 1
    { position: 165, track: 2, type: 3, flip: 1 },
    { position: 196, track: 1, type: 6, flip: 1 },
    { position: 196, track: 3, type: 6, flip: 1 },
    { position: 222, track: 2, type: 1, flip: 1 },

    { position: 248, track: 3, type: 6, flip: 0 },
    { position: 248, track: 2, type: 6, flip: 0 },

    { position: 284, track: 1, type: 1, flip: 1 },
    { position: 284, track: 3, type: 1, flip: 1 },

    { position: 301, track: 1, type: 3, flip: 0 },

    { position: 317, track: 1, type: 1, flip: 1 },
    { position: 317, track: 2, type: 6, flip: 1 },

    { position: 342, track: 2, type: 6, flip: 1 },
    { position: 342, track: 3, type: 6, flip: 1 },

    // Level 2 Tutorial
    { position: 470, track: 1, type: 1, flip: 0 },
    { position: 470, track: 2, type: 1, flip: 0 },
    { position: 470, track: 3, type: 1, flip: 0 },

    // Level 2
    { position: 500, track: 1, type: 5, flip: 0 },

    { position: 528, track: 2, type: 1, flip: 0 },
    { position: 542, track: 1, type: 2, flip: 0 },

    { position: 575, track: 1, type: 4, flip: 0 },
    { position: 590, track: 3, type: 5, flip: 1 },

    { position: 620, track: 1, type: 1, flip: 0 },
    { position: 620, track: 3, type: 1, flip: 1 },

    { position: 640, track: 2, type: 5, flip: 0 },

    { position: 660, track: 1, type: 1, flip: 0 },
    { position: 660, track: 2, type: 2, flip: 0 },

    { position: 690, track: 3, type: 1, flip: 1 },
    { position: 710, track: 2, type: 1, flip: 1 },
    { position: 728, track: 1, type: 1, flip: 1 },

    { position: 745, track: 2, type: 2, flip: 0 },

    { position: 770, track: 2, type: 5, flip: 1 },

    { position: 796, track: 3, type: 1, flip: 0 },
    { position: 796, track: 2, type: 1, flip: 0 },
    { position: 812, track: 1, type: 4, flip: 0 },

    { position: 836, track: 1, type: 1, flip: 0 },
    { position: 836, track: 3, type: 1, flip: 1 },
    { position: 850, track: 2, type: 2, flip: 0 },

    { position: 884, track: 2, type: 5, flip: 0 },

    { position: 902, track: 3, type: 1, flip: 0 },
    { position: 916, track: 1, type: 4, flip: 0 },

    // Level 3 Tutorial
    { position: 1060, track: 2, type: 1, flip: 0 },
    { position: 1060, track: 3, type: 1, flip: 0 },

    { position: 1080, track: 1, type: 5, flip: 0 },

    { position: 1100, track: 1, type: 4, flip: 0 },

    { position: 1120, track: 3, type: 5, flip: 1 },
    { position: 1120, track: 1, type: 1, flip: 0 },

     { position: 1140, track: 2, type: 1, flip: 0 },

    // Level 3
    { position: 1160, track: 1, type: 4, flip: 0 },

    { position: 1210, track: 1, type: 1, flip: 0 },
    { position: 1226, track: 2, type: 6, flip: 0 },
    { position: 1260, track: 2, type: 5, flip: 0 },
    { position: 1280, track: 1, type: 6, flip: 0 },
    { position: 1280, track: 3, type: 6, flip: 1 },

    { position: 1310, track: 1, type: 1, flip: 0 },
    { position: 1322, track: 2, type: 6, flip: 0 },
    { position: 1322, track: 3, type: 6, flip: 1 },
    { position: 1336, track: 1, type: 4, flip: 0 },
    { position: 1360, track: 1, type: 1, flip: 0 },
    { position: 1360, track: 2, type: 1, flip: 0 },

    { position: 1390, track: 3, type: 5, flip: 1 },
    { position: 1410, track: 2, type: 6, flip: 0 },
    { position: 1430, track: 2, type: 1, flip: 0 },
    { position: 1430, track: 3, type: 1, flip: 0 },
    { position: 1442, track: 1, type: 6, flip: 1 },
    { position: 1442, track: 2, type: 6, flip: 0 },
    { position: 1460, track: 3, type: 1, flip: 0 },

    { position: 1500, track: 1, type: 1, flip: 0 },
    { position: 1500, track: 3, type: 1, flip: 0 },
    { position: 1520, track: 2, type: 6, flip: 0 },
    { position: 1536, track: 3, type: 5, flip: 1 },
    { position: 1550, track: 1, type: 4, flip: 0 },
    { position: 1564, track: 1, type: 1, flip: 0 },
    { position: 1580, track: 2, type: 6, flip: 1 },
    { position: 1580, track: 3, type: 6, flip: 0 },

    { position: 1600, track: 2, type: 1, flip: 0 },
    { position: 1612, track: 1, type: 6, flip: 0 },
    { position: 1624, track: 3, type: 5, flip: 1 },
    { position: 1640, track: 1, type: 1, flip: 0 },
    { position: 1650, track: 2, type: 6, flip: 0 },
    { position: 1664, track: 1, type: 4, flip: 0 },
    { position: 1678, track: 2, type: 1, flip: 0 },
    { position: 1690, track: 1, type: 6, flip: 0 },
    { position: 1702, track: 2, type: 5, flip: 1 },

    { position: 1720, track: 2, type: 5, flip: 0 },
    { position: 1720, track: 1, type: 1, flip: 0 },

      // Level 4
    { position: 1900, track: 2, type: 6, flip: 0 },

    { position: 1920, track: 1, type: 3, flip: 0 },
    { position: 1936, track: 3, type: 6, flip: 0 },

    { position: 1960, track: 2, type: 3, flip: 0 },
    { position: 1976, track: 1, type: 6, flip: 0 },

    { position: 2000, track: 1, type: 5, flip: 0 },
    { position: 2014, track: 3, type: 7, flip: 1 },

    { position: 2040, track: 1, type: 3, flip: 0 },
    { position: 2040, track: 3, type: 6, flip: 0 },
    { position: 2056, track: 2, type: 5, flip: 1 },

    { position: 2084, track: 2, type: 3, flip: 0 },
    { position: 2098, track: 1, type: 6, flip: 0 },
    { position: 2112, track: 2, type: 7, flip: 1 },

    { position: 2140, track: 1, type: 6, flip: 0 },
    { position: 2140, track: 3, type: 6, flip: 0 },
    { position: 2154, track: 2, type: 5, flip: 0 },

    { position: 2180, track: 1, type: 3, flip: 0 },
    { position: 2194, track: 3, type: 6, flip: 0 },
    { position: 2208, track: 3, type: 7, flip: 1 },

    { position: 2240, track: 2, type: 3, flip: 0 },
    { position: 2254, track: 1, type: 6, flip: 0 },
    { position: 2268, track: 2, type: 5, flip: 0 },

    { position: 2300, track: 1, type: 3, flip: 0 },
    { position: 2300, track: 3, type: 6, flip: 0 },
    { position: 2314, track: 2, type: 6, flip: 0 },

    { position: 2344, track: 2, type: 3, flip: 0 },
    { position: 2358, track: 1, type: 5, flip: 0 },
    { position: 2380, track: 2, type: 6, flip: 0 },

    { position: 2405, track: 1, type: 6, flip: 0 },
    { position: 2405, track: 3, type: 6, flip: 0 },
    { position: 2424, track: 2, type: 7, flip: 1 },

    { position: 2444, track: 1, type: 3, flip: 0 },
    { position: 2458, track: 3, type: 5, flip: 1 },
    { position: 2472, track: 2, type: 6, flip: 0 },

    { position: 2500, track: 2, type: 3, flip: 0 },
    { position: 2514, track: 1, type: 6, flip: 0 },
    { position: 2528, track: 2, type: 5, flip: 1 },

    { position: 2560, track: 1, type: 3, flip: 0 },
    { position: 2560, track: 3, type: 6, flip: 0 },
    { position: 2590, track: 3, type: 7, flip: 1 },
    { position: 2590, track: 1, type: 6, flip: 0 },

    { position: 2618, track: 1, type: 5, flip: 0 },
    { position: 2642, track: 2, type: 6, flip: 0 },

    { position: 2662, track: 1, type: 6, flip: 0 },
    { position: 2662, track: 3, type: 6, flip: 0 },
    { position: 2685, track: 2, type: 5, flip: 0 },
]
